import React, { FC } from "react";

import styles from "./styles.module.scss";

interface FooterProps {
  goTo: string;
  footerActionText: string;
  footerAction: () => void;
}

const Footer: FC<FooterProps> = ({ goTo, footerActionText, footerAction }) => {
  return (
    <div className={styles.goTo}>
      <p>{goTo}</p>

      <button onClick={footerAction}>{footerActionText}</button>
    </div>
  );
};

export default Footer;
